<template>
  <q-page>
    <div class="q-pa-md">
      <div class="row justify-between q-mb-md">
        <div class="row items-center">
          <div class="page-title q-mr-sm">Articles</div>
          <div>
            <q-btn
              @click="onAddArticlesClick"
              color="primary"
              class="float-right sustainability-button"
            >
              <q-icon name="mdi-plus-circle"> </q-icon>
              <span class="sustainability-font q-mx-sm" style="font-size: 13px">
                Add
              </span>
            </q-btn>
          </div>
        </div>
        <div>
          <q-input
            class="searchbar float-right"
            filled
            v-model="search"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row">
        <q-card
          class="full-width shadow-10 sustainability-card-radius"
          style="height: calc(100vh - 195px)"
        >
          <sustainability-datatable
            flat
            :data="data"
            :filter="search"
            :columns="columns"
            headerBgColor="#162c47"
            headerTextColor="white"
            @rowDoubleClick="onRowDoubleClick"
            :cellBodyStyle="cellBodyStyle"
            :pagination="{
              sortBy: 'title',
              descending: false,
              rowsPerPage: 0,
            }"
          >
            <template slot="body-cell-progressStatus" slot-scope="data">
              <q-td :props="data.props">
                <q-img
                  :style="`background-color: ${data.props.row.progressStatus};width: 20px;height: 20px; border-radius: 100px;`"
                >
                  <q-tooltip>
                    {{ getStatusDescription(data.props.row.progressStatus) }}
                  </q-tooltip>
                </q-img>
              </q-td>
            </template>
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  class="float-right"
                  round
                  flat
                  color="red"
                  icon="mdi-delete"
                  @click="removeArticle(data.props.row)"
                  size="md"
                >
                  <q-tooltip> Delete Article </q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </sustainability-datatable>
        </q-card>
      </div>
    </div>
    <q-dialog v-model="articleDialog" full-width full-height persistent>
      <article-form @closeDialog="closeDialog"></article-form>
    </q-dialog>
  </q-page>
</template>

<script>
import SustainabilityDatatable from "@/components/datatable/sustainabilityDatatable.vue";
import ArticleForm from "@/components/articles/articleForm.vue";
import { mapGetters } from "vuex";
export default {
  data: () => ({
    search: "",
    articleDialog: false,

    progressStatusOptions: [
      {
        color: "red",
        description: "Draft",
        label: "Red",
      },
      {
        color: "orange",
        description: "Complete but needs Revision",
        label: "Orange",
      },
      {
        color: "green",
        description: "Complete and live",
        label: "Green",
      },
    ],
  }),
  computed: {
    ...mapGetters({
      data: "articles/list",
    }),
    cellBodyStyle() {
      return "font-family: 'Montserrat';font-style: normal;font-weight: 400;font-size: 14px;line-height: 17px;display: flex;align-items: center;letter-spacing: -0.02em;color: black;";
    },
    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "title",
          label: "Title",
          align: "left",
          field: "title",
          style:
            "min-width: 400px;max-width: 400px;width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },

        {
          name: "outcome",
          label: "Outcome",
          align: "left",
          field: "outcomeName",
          style:
            "min-width:200px;max-width: 200px;width:200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "readMinutes",
          label: "Total Read Minutes",
          align: "left",
          field: "totalReadMins",
          style:
            "min-width: 90px;max-width: 90px;width: 90px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "progressStatus",
          label: "Status",
          align: "left",
          field: "progressStatus",
          style:
            "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => this.$options.filters.gridDateFormat(val),
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "actions",
          label: "Actions",
          align: "right",
        },
      ];
    },
  },
  mounted() {
    this.$store.dispatch("articles/loadAll");
    if (this.$route.params.hasOwnProperty("id")) {
      this.openSelectedArticle(this.$route.params.id);
    }
  },
  components: {
    SustainabilityDatatable,
    ArticleForm,
  },
  watch: {
    $route: {
      handler(value) {
        if (value.params.hasOwnProperty("id")) {
          this.openSelectedArticle(value.params.id);
        }
      },
    },
  },
  methods: {
    getStatusDescription(color) {
      let index = this.progressStatusOptions.findIndex((e) => e.color == color);
      if (index > -1) {
        return this.progressStatusOptions[index].description;
      }
    },
    closeDialog() {
      this.articleDialog = false;
      this.$router.push("/articles");
    },
    onRowDoubleClick(row) {
      this.$router.push("/articles/" + row.id);
    },
    async onAddArticlesClick() {
      this.isLoading = true;
      let result = await this.$store.dispatch("articles/new", {
        status: "temp",
      });
      this.$router.push(
        "/articles/" + parseFloat(result.Response.newArticleId)
      );
      this.isLoading = false;
    },
    openSelectedArticle(id) {
      this.$store.commit("articles/setSelectedArticle", null);
      this.$store.dispatch("keywords/loadAll");
      this.$store.dispatch("articles/loadByID", id);
      this.$store.dispatch("articles/keywords/loadAllByArticlesID", id);
      this.$store.dispatch("articles/links/loadAllByArticlesID", id);
      this.$store.dispatch("articles/solutions/loadAllByArticlesID", id);
      this.$store.dispatch("solutions/loadAll");
      this.$nextTick(() => (this.articleDialog = true));
    },
    removeArticle(row) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = { ...row };
          payload.deleted_at = new Date();
          this.$store.dispatch("articles/save", payload).then((result) => {
            if (result.Result == "Success") {
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: "The Article has been removed.",
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;
}

.sustainability-button {
  height: 34px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 9px;
  line-height: 11px;
  display: flex;
  align-items: center;
  text-align: center;
}
</style>
